import "./DashboardCards.css";
import {
  FaBookOpen,
  FaCertificate,
  FaWallet,
  FaBriefcase,
} from "react-icons/fa";

const cards = [
  {
    id: 1,
    title: "Courses",
    value: "04",
    subtitle: "Available",
    icon: <FaBookOpen />,
    color: "blue",
  },
  {
    id: 2,
    title: "Certificates",
    value: "12",
    subtitle: "Completed",
    icon: <FaCertificate />,
    color: "green",
  },
  {
    id: 3,
    title: "Fees",
    value: "₹28K",
    subtitle: "Total Paid",
    icon: <FaWallet />,
    color: "orange",
  },
  {
    id: 4,
    title: "Career",
    value: "98%",
    subtitle: "Placement Support",
    icon: <FaBriefcase />,
    color: "purple",
  },
];

function DashboardCards() {
  return (
    <div id="student-dashboard" className="student-page-dashboard-cards">
      {cards.map((card, index) => (
        <div
          className={`student-page-dashboard-card student-page-dashboard-card-${card.color}`}
          key={card.id}

        >
          <div className="student-page-dashboard-card-top">
            <div>
              <h4>{card.title}</h4>
              <h2>{card.value}</h2>
              <p>{card.subtitle}</p>
            </div>

            <div className="student-page-dashboard-card-icon">{card.icon}</div>
          </div>

          <div className="student-page-dashboard-progress-line">
            <span></span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default DashboardCards;
